<template>
  <v-row align="center" justify="center">
    <v-col cols="12" sm="8" md="4">
      <v-card flat color="transparent mt-auto mb-auto">
        <v-card-text class="pb-0">
          <p class="text-center"><img src="../assets/logo-large.png" /></p>
          <v-row align="center" justify="center">
            <v-col cols="10">
              <p class="text-center">
                <v-progress-linear
                  indeterminate
                  color="primary"
                  height="5"
                  class="mt-5"
                  rounded
                ></v-progress-linear>
              </p>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
export default {};
</script>

<style></style>
